import { render } from "./RulesPanelPage.vue?vue&type=template&id=2b2e2c89&scoped=true"
import script from "./RulesPanelPage.vue?vue&type=script&lang=js"
export * from "./RulesPanelPage.vue?vue&type=script&lang=js"

import "./RulesPanelPage.vue?vue&type=style&index=0&id=2b2e2c89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2e2c89"]])

export default __exports__